// Experimental mobile "mosaic" product gallery.
// Everything except this tap-to-promote interaction is handled by the
// existing <media-gallery>/<slider-component> elements (media-gallery.js)
// reused unmodified by snippets/product-media-gallery-mosaic.liquid.
document.addEventListener(
  'click',
  (event) => {
    const item = event.target.closest('.product__media-list--mosaic .product__media-item');
    if (!item || item.classList.contains('is-active')) return;

    const mediaGallery = item.closest('media-gallery');
    if (!mediaGallery) return;

    event.stopPropagation();

    mediaGallery.setActiveMedia(item.dataset.mediaId, true);

    const track = mediaGallery.querySelector('.product__media-list--mosaic');
    if (track) track.scrollTo({ left: 0, behavior: 'smooth' });
  },
  true
);
